import React, { useState } from 'react';
import Image from 'next/image';

import useSlugify from 'utils/useSlugify';

import styles from './CarLogo.module.scss';

interface CarLogoProps {
  brand: string;
  vehicleType: string;
  size?: number;
}

export const CarLogo: React.FC<CarLogoProps> = ({ brand, vehicleType, size = 96 }) => {
  const slug = useSlugify(brand);
  const [imgSrc, setImgSrc] = useState(`/assets/car-logos/${slug}.svg`);

  return (
    <div className={size ? '' : styles.wrapper}>
      <Image
        className={styles.image}
        src={imgSrc}
        width={size}
        height={size}
        objectFit="contain"
        onError={() => {
          setImgSrc(
            `/assets/car-logos/${vehicleType ? vehicleType.toLowerCase() : 'car'}-placeholder.svg`
          );
        }}
      />
    </div>
  );
};
